import React, { Component } from 'react';
import {
    BrowserRouter,
    Route,
    Switch,
} from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import AppContainer from '@appblocks/frontend/AppContainer';
import CustomDragLayer from '@appblocks/frontend/client/Components/TPP/CustomDragLayer';
import { CustomShapeProvider } from '@appblocks/frontend/client/Components/PeripheralsWiringEditor/CustomShapeContext';
import SuperTokens, { SuperTokensWrapper } from 'supertokens-auth-react';
import { PreBuiltUIList, SuperTokensConfig } from '@appblocks/frontend/config/st_config';

SuperTokens.init(SuperTokensConfig);

export default class App extends Component {
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    render() {
        return (
            <SuperTokensWrapper>
                <BrowserRouter>
                    <CustomShapeProvider>
                        <DndProvider backend={HTML5Backend}>
                            <AppContainer />
                            <CustomDragLayer />
                        </DndProvider>
                    </CustomShapeProvider>
                </BrowserRouter>
            </SuperTokensWrapper>
        );
    }
}
